import { arrayToBase64, base64ToArray } from '@lucidlink/ts-crypto/crypto';
export const createBase64RsaCryptoAsync = (crypto) => {
    return new WebCryptoBase64Rsa(crypto);
};
class WebCryptoBase64Rsa {
    crypto;
    constructor(crypto) {
        this.crypto = crypto;
    }
    async encrypt(unencrypted) {
        const encrypted = await this.crypto.encrypt(unencrypted);
        return arrayToBase64(encrypted.buffer);
    }
    async decrypt(encrypted) {
        const decoded = new Uint8Array(base64ToArray(encrypted));
        return this.crypto.decrypt(decoded);
    }
    async encryptLong(unencrypted) {
        const blocks = await this.crypto.encryptLong(unencrypted);
        return blocks.map((block) => arrayToBase64(block.buffer));
    }
    async decryptLong(encrypted) {
        const blocks = encrypted.map((block) => new Uint8Array(base64ToArray(block)));
        return this.crypto.decryptLong(blocks);
    }
}
